export * from './relocation.component';
export * from './address-info.component';